import { type ISubmitApplicationActionPayload } from 'src/types/leaveApplications/types';

export const dumpSubmitApplicationAction = (vacationId: number, stage: number): ISubmitApplicationActionPayload => {
  return {
    id: vacationId,
    stage
  };
};
